// extracted by mini-css-extract-plugin
module.exports = {"favorite":"Favorite_favorite__215WW","programCode":"Favorite_programCode__1w4r7"};